module.exports = __webpack_public_path__ + "media/images/solo-150-new-e5929acbb4c2bd05a8605685ed0f536e.webp";